export default function ({ route, $authService }) {
  if ($authService.loggedIn === true && $authService.hasState === false) {
    return $authService.refreshState();
  } else {
    return Promise.resolve(route);
  }
}
